import { Outlet } from 'react-router-dom';
import { useEffect, useCallback, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { getModes, getPlans, initUser } from '../../../store/UserSlice';
import { AlertType } from '../../../types/common';
import { showAlert } from '../../../store';
import { AreaLoader } from '../../UI';

export const InitApp = () => {
  const dispatch = useAppDispatch();
  const [isInitDataReceived, setIsInitDataReceived] = useState(false);

  const user = useAppSelector((state) => state.user);

  const startApp = useCallback(async () => {
    try {
      const user = await dispatch(initUser()).unwrap();

      if (user) {
        await dispatch(getModes());
        await dispatch(getPlans());
        setIsInitDataReceived(true);
      }
    } catch (e: any) {
      dispatch(showAlert({ type: AlertType.Error, message: 'Произошла ошибка при авторизации' }));
    }
  }, [dispatch]);

  useEffect(() => {
    startApp();
  }, [startApp]);

  if (!isInitDataReceived || !user) {
    return <AreaLoader />;
  }

  return <Outlet />;
};
